export { default as fetchQuery } from "./fetchQuery.js";
export { default as parseGraphQl } from "./parseGraphQl.js";
